<template>
  <div class="tiles--wrapper">     
    <Tile v-for="item in items" :key="item.id" :item="item"/>
  </div>
</template>

<script>


export default {
  name: "Tiles",
  components: {
    Tile: () => import(/* webpackPrefetch: true */ './Tile.vue')
  },
  props: {
      items: {
          type: Object,
          default: function () {
              return {}
          }
      }
  },
  data() {
    return {
        errors: []
    };
  },
  mounted() {
    this.init();
    this.resize();
  },
  methods: {
    resize() {
    },
    init() {
      this.processItems();
    },
    async processItems() {
      var items = this.items;
      if (window.innerWidth < 960) {
        var itemsArray = [];
        itemsArray = Object.keys(items).map((key) => items[key]);
        for(var i=0; i < itemsArray.length; i++) {
          if(itemsArray[i].hide_mobile == 1) {
            var id = itemsArray[i].id;
            delete items[id];
          }
        }
      } 
    },
  },
  computed: {
  }
};
</script>

<style scoped lang="scss">
.tiles--wrapper {
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap;
}
</style>